// extracted by mini-css-extract-plugin
module.exports = {"ArticleSummary":"ArticleSummary_ArticleSummary__3I5Qk","ArticleImage":"ArticleSummary_ArticleImage__3b0TR"};